import clsx from "clsx";
import React, { ButtonHTMLAttributes, DetailedHTMLProps, FC } from "react";

import { Icon } from "../../icon";

export interface PaginationArrowButtonProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  direction: "left" | "right";
}

export const PaginationArrowButton: FC<PaginationArrowButtonProps> = ({
  direction,
  className,
  ...props
}) => {
  return (
    <button className={clsx("w-9 h-9 flex items-center justify-center", className)} {...props}>
      <Icon
        icon="chevron-up"
        className={clsx(
          "w-5 px-1",
          props?.disabled && "opacity-75 cursor-not-allowed",
          direction === "left" && "-rotate-90",
          direction === "right" && "rotate-90"
        )}
      />
    </button>
  );
};
